// What the Books screen says about each book (ticket 60): who wrote the
// description, where the book stands, and whether it looks like test data.
// "Live" here is the book's status, not what an author means by it.

export const wordCount = (text) => {
  const t = (text || '').trim();
  return t ? t.split(/\s+/).length : 0;
};

export const isReaderCopy = (book) =>
  book?.description_source === 'reader' || (book?.reader_description || '').trim() !== '';

// An author-described book whose archived reader description still feeds matching: book_embedding_source()
// joins the two into the one text the book is matched on (20261007000000_embedding_includes_book_facts.sql).
export const matchesTwoTexts = (book) =>
  book?.is_author_described === true && (book?.reader_description || '').trim() !== '';

// The same number the author sees on My Books: whole days since live_at.
export function daysLive(book, now = Date.now()) {
  if (!book?.live_at) return null;
  return Math.max(0, Math.floor((now - new Date(book.live_at).getTime()) / 86400000));
}

export function standingText(book, now = Date.now()) {
  if (book?.status === 'live') {
    const d = daysLive(book, now);
    if (d !== null) return d === 0 ? 'went live today' : `${d} day${d === 1 ? '' : 's'} live`;
  }
  if (!book?.created_at) return null;
  const diff = now - new Date(book.created_at).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 60) return m < 1 ? 'saved just now' : `saved ${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `saved ${h}h ago`;
  const d = Math.floor(h / 24);
  return d < 30 ? `saved ${d}d ago` : `saved ${Math.floor(d / 30)}mo ago`;
}

// Candidates, not facts: a guess from the title and the author's name.
const TITLE_HINT = /\b(test|testing|tester|asdf+|qwerty|lorem ipsum|dummy|placeholder|pickar|chess piece)\b/i;
const AUTHOR_HINT = /\b(test|testing|tester|asdf+|qwerty|rewq|dummy|placeholder|author author)\b/i;

export function testDataReasons(book) {
  const reasons = [];
  const title = (book?.title || '').trim();
  const author = (book?.author_name || '').trim();
  const t = title.match(TITLE_HINT);
  if (t) reasons.push(`the title has "${t[0]}"`);
  const a = author.match(AUTHOR_HINT);
  if (a) reasons.push(`the author name has "${a[0]}"`);
  if (title && author && title.toLowerCase() === author.toLowerCase()) reasons.push('the title and the author name are the same');
  return reasons;
}

// A live, author-described book can reach the swipe deck.
export const isSwipeable = (book) => book?.status === 'live' && book?.is_author_described === true;

// Swipeable candidates first, then by title.
export function sortTestData(books) {
  return [...books].sort((a, b) => {
    const s = Number(isSwipeable(b)) - Number(isSwipeable(a));
    return s !== 0 ? s : (a.title || '').localeCompare(b.title || '');
  });
}

export const BOOK_ROW_FIELDS =
  'id, title, author_name, cover_image_url, status, submission_type, entry_point, created_at, live_at, author_id, claimed_at, ' +
  'is_author_described, description_source, reader_description, edition_count, ratings_count, popularity_checked_at, ' +
  'popularity_override:book_popularity_overrides ( class, reason, set_at ), ' +
  'claimant:authors!books_author_id_fkey ( id, display_name, email )';
